// removed by extract-text-webpack-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","label":"label-e2SH0","allowSelect":"allowSelect-ooNWZ","container":"container-nbJg5","cardInfo":"cardInfo-cYJID","cardIcon":"cardIcon-CMr2K","link":"link-1Gepi link-1i3sH","input":"input-1Tzg1","cardMoreInfo":"cardMoreInfo-1n05u","editIcon":"editIcon-2GXja"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_billingProfile.css
// module id = 1242
// module chunks = 1